"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var InputBase_1 = __importDefault(require("@mui/material/InputBase"));
var formik_1 = require("formik");
var react_1 = require("react");
var theme_1 = require("../../../theme");
var TextField = (0, react_1.forwardRef)(function TextField(props, ref) {
    var _a;
    var name = props.name, label = props.label, error = props.error;
    var disableFormik = props.disableFormik, helperText = props.helperText, inputProps = props.inputProps, InputProps = props.InputProps, InputLabelProps = props.InputLabelProps, bgColor = props.bgColor, validate = props.validate, forceError = props.forceError, rest = __rest(props, ["disableFormik", "helperText", "inputProps", "InputProps", "InputLabelProps", "bgColor", "validate", "forceError"]);
    var _b = __read((0, formik_1.useField)({ name: name, validate: validate }), 2), field = _b[0], meta = _b[1];
    return ((0, jsx_runtime_1.jsxs)(material_1.FormControl, __assign({ variant: "standard", fullWidth: true, error: meta.touched && error }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: "row", spacing: 0.5 }, { children: [(0, jsx_runtime_1.jsx)(material_1.InputLabel, __assign({ shrink: true, htmlFor: name, sx: (_a = {
                                textTransform: 'capitalize',
                                transform: 'none',
                                color: '#000000',
                                pl: 0.5,
                                '&:not(.Mui-error).Mui-focused': {
                                    color: '#9ea3f2',
                                },
                                position: 'relative',
                                lineHeight: '1.66',
                                fontSize: (0, theme_1.pxToRem)(10)
                            },
                            _a["@media (min-width:".concat(theme_1.breakpoints.desktop, "px)")] = {
                                fontSize: (0, theme_1.pxToRem)(11),
                            },
                            _a) }, InputLabelProps, { children: (0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: "row", margin: 0, spacing: 1 }, { children: [label, rest.required && ((0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ component: "span", fontSize: (0, theme_1.pxToRem)(25), lineHeight: "1.66", height: "1.66px", position: "relative", top: "-0.3em" }, { children: "*" })))] })) })), ((meta.touched && helperText) || forceError !== undefined) && ((0, jsx_runtime_1.jsxs)(material_1.FormHelperText, __assign({ sx: { fontSize: (0, theme_1.pxToRem)(10) } }, { children: ["- ", forceError || helperText] })))] })), (0, jsx_runtime_1.jsx)(InputBase_1.default, __assign({ ref: ref, id: name, sx: {
                    'label + &': {
                        marginTop: function (theme) { return theme.spacing(2.5); },
                    },
                    borderRadius: 2,
                    position: 'relative',
                    backgroundColor: bgColor,
                    border: '1px solid',
                    borderColor: 'secondary.light',
                    py: 2,
                    minHeight: '52px',
                    px: 2.5,
                    '& .MuiInputBase-input': {
                        transition: function (theme) { return theme.transitions.create(['border-color']); },
                        ':not(.Mui-error) &:focus': {
                            borderColor: '#9ea3f2',
                        },
                    },
                    '&.Mui-readOnly': {
                        borderRadius: 0,
                        borderWidth: 0,
                        marginTop: field.value === '' || field.value === null ? -2 : 0,
                        borderBottomWidth: field.value === '' || field.value === null ? 1 : 0,
                        backgroundColor: 'transparent',
                        paddingLeft: 0.5,
                        fontWeight: 'bold',
                    },
                }, inputProps: inputProps }, rest, (disableFormik ? {} : field))), (0, jsx_runtime_1.jsx)(formik_1.ErrorMessage, __assign({ name: name }, { children: function (msg) { return (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ color: "redWarning.dark" }, { children: msg })); } }))] })));
});
TextField.defaultProps = {
    disableFormik: false,
    helperText: undefined,
    InputProps: undefined,
    InputLabelProps: undefined,
    validate: undefined,
    bgColor: 'secondary.dark',
    forceError: undefined,
};
exports.default = TextField;
//# sourceMappingURL=TextField.js.map